import HeroSection from "../components/sections/HeroSection";
import HeroImage from '../assets/images/heros/hero-five.jpg';
import heroSectionData from "../data/english/hero-section-data";
import homePageData from "../data/english/home-page-data";
import ReactVisibilitySensor from "react-visibility-sensor";
import ChairmanImage from '../assets/images/people/chairman-image.jpg';
import GallerySection from "../components/sections/GallerySection/GallerySection";
import GallerySectionRow from "../components/sections/GallerySection/GallerySectionRow";
import GallerySectionCol from "../components/sections/GallerySection/GallerySectionCol";
import GalleryCard from "../components/cards/GalleryCard";
import ImageAndBoxSection from "../components/sections/ImageAndBoxSection/ImageAndBoxSection";
import backgroundOne from '../assets/images/backgrounds/background-1.jpg';
import GridSection from "../components/sections/GridSection/GridSection";
import FlexViewOne from "../components/FlexView/FlexViewOne";
import BackgroundCard from "../components/cards/BackgroundCard";
import TranslateTopWrapper from "../components/Wrappers/TranslateTopWrapper";
import PrimaryCard from "../components/cards/PrimaryCard";
import FlexViewTwo from "../components/FlexView/FlexViewTwo/FlexViewTwo";
import Footer from "../layouts/Footer";
import AriabianWoman from '../assets/images/backgrounds/arabian-woman-overlay.jpg';
import BackgroundSection from "../components/sections/BackgroundSection/BackgroundSection";
import { useContext } from "react";
import InfoBox from "../components/boxes/InfoBox";
import { LangContext } from "../App";

const HomePage = () => {
    const { lang } = useContext(LangContext);


    return (
            <>
            <main className="page" id="main">
                <div className="sticky-view">
                    <div className="sticky-container">
                        <HeroSection 
                            title={heroSectionData.title}
                            subtitle={heroSectionData.subtitle}
                            image={HeroImage}
                        />
                    </div>
                    <div className="sticky-container-two" id="mainContent">
                    <BackgroundSection 
                        title={homePageData.sectionOne.title}
                        subtitle={homePageData.sectionOne.subtitle}
                        image={{
                            src : AriabianWoman,
                            alt : "Ariabian Woman Smiling",
                        }}
                        button={{
                            text : homePageData.sectionOne.button.text,
                            path : homePageData.sectionOne.button.path,
                            buttonTitle : "Go to ESG Strategy page"
                        }}
                    />
                    <section id="chairman" className="chairman-section">
                        <ReactVisibilitySensor
                            partialVisibility
                        >
                        {({isVisible} : any) => (
                            <img 
                                src={ChairmanImage} 
                                className={`bg-image an-scale-up ${isVisible ? "an-active" : ""}`} 
                                alt={homePageData.chairmanSection.info.name} 
                            />
                        )}
                        </ReactVisibilitySensor>
                        <div className="content">
                            <div className="wrapper-small">
                                <div className="content-box">
                                    <ReactVisibilitySensor
                                        partialVisibility
                                    >
                                    {({isVisible} : any) => (
                                        <p className={`description an-move-top-fade-in ${isVisible ? "an-active" : ""}`}>
                                            {homePageData.chairmanSection.description}
                                        </p>
                                    )}
                                    </ReactVisibilitySensor>
                                    <ReactVisibilitySensor
                                        partialVisibility
                                    >
                                    {({isVisible} : any) => (
                                        <div className={`an-scale-x-fade-in ${isVisible ? "an-active" : ""}`}>
                                        <div className={`boardered-box `}>
                                            <h2 className={`title ${isVisible ? "an-active" : ""}`}>{homePageData.chairmanSection.info.name}</h2>
                                            <h3 className="subtitle">{homePageData.chairmanSection.info.position}</h3>
                                        </div>
                                        </div>
                                    )}
                                    </ReactVisibilitySensor>
                                </div>
                            </div>
                        </div>
                    </section>
                    <div className="wrapper-small">
                        <GallerySection>
                            <GallerySectionRow>
                            {homePageData.gallerySection.rowOne.map((item, index) => (
                                <GallerySectionCol key={index}>
                                    <GalleryCard
                                        title={item.title}
                                        subtitle={item.subtitle}
                                        button={item.button}
                                        image={{
                                            src : require(`../assets/images/cards/${item.image.src}`),
                                            alt : item.image.alt,
                                        }}
                                    />
                                </GallerySectionCol>
                            ))}
                            </GallerySectionRow>
                            <GallerySectionRow>
                            {homePageData.gallerySection.rowTwo.map((item, index) => (
                                <GallerySectionCol key={index}>
                                    <GalleryCard
                                        title={item.title}
                                        subtitle={item.subtitle}
                                        button={item.button}
                                        image={item.image ? {
                                            src : require(`../assets/images/cards/${item.image.src}`),
                                            alt : item.image.alt,
                                        } : undefined}
                                    />
                                </GallerySectionCol>
                            ))}
                            </GallerySectionRow>
                        </GallerySection>
                    </div>
                    <div className="wrapper-larg">
                        <ImageAndBoxSection 
                            title={homePageData.imageAndBoxSection.title}
                            subtitle={homePageData.imageAndBoxSection.subtitle}
                            button={homePageData.imageAndBoxSection.button}
                            image={{
                                src : backgroundOne,
                                alt : homePageData.imageAndBoxSection.image.alt
                            }}
                        />
                    </div>

                <GridSection>
                    <>
                    <div className="wrapper-larg">
                        <TranslateTopWrapper>
                            <FlexViewOne>
                            {homePageData.gridSection.flexOne.map((item, index) => (
                                <BackgroundCard 
                                    key={index}
                                    background={{
                                        src : item.type === "image" ? require(`../assets/images/cards/${item.image.name}`) : require(`../assets/videos/${item.image.name}`),
                                        alt : item.image.alt
                                    }}
                                    title={item.title}
                                    type={item.type}
                                    path={item.path}
                                />
                            ))}
                            </FlexViewOne>
                        </TranslateTopWrapper>
                    </div>
                    <div className="wrapper-small">
                        {/* <div className="grid-section-info-box">
                            <p className="description">{homePageData.gridSection.boxOne.description}</p>
                            <button
                                // to={homePageData.gridSection.boxOne.button.path}
                                className="button"
                                onClick={() => handleChangePage(pagesNames.vision)}
                            >{homePageData.gridSection.boxOne.button.text}</button>
                        </div> */}
                        <InfoBox 
                            description={homePageData.gridSection.boxOne.description}
                            button={homePageData.gridSection.boxOne.button}
                        />
                    </div>
                    <div className="wrapper-small">
                        <div className="flex-view-blog">
                        {homePageData.gridSection.flexTwo.map((item, index) => (
                            // <ReactVisibilitySensor
                            //     partialVisibility
                            // >
                            // {({isVisible} : any) => (
                                <PrimaryCard
                                    key={index}
                                    title={item.title}
                                    subtitle={item.subtitle}
                                    button={item.button}
                                    image={{
                                        src : require(`../assets/images/cards/${item.image.name}`),
                                        alt : item.image.alt,
                                    }}
                                    // className={`an-move-top-fade-in active`}
                                />
                            // )}
                            // </ReactVisibilitySensor>
                        ))}
                        </div>
                    </div>
                    </>
                </GridSection>
                    </div>
                </div>
                <Footer withBlogs={true} />
            </main>
            </>
    )
}

export default HomePage;